$(document).on('turbolinks:load', function () {
  window.removeImage = function(button) {
    const imageContainer = button.closest('.position-relative');
    const destroyField = imageContainer.querySelector('.destroy-image');
    if (destroyField) {
      destroyField.value = '1';
    }
    imageContainer.style.display = 'none';
  };

  window.addImageField = function() {
    const imageFields = document.getElementById('image-fields');
    const timestamp = new Date().getTime();
    const newField = document.createElement('div');
    newField.className = 'mb-2';
    newField.innerHTML = `
      <div class="d-flex justify-content-start align-items-center gap-3 pt-1">
        <div class="position-relative cursor-pointer mobject-fit" style="max-width: 140px; width: 140px;">
          <div class="position-absolute top-0 btn-file-input-mess">
            ファイルを選択
          </div>
          <input type="file" name="admin_message[admin_messages_images_attributes][${timestamp}][file]"
                 id="admin_message_image_${timestamp}"
                 class="opacity-0" accept=".jpg,.png,.jpeg" onchange="previewImage(this, false)" data-field-id="${timestamp}" />
        </div>
        <div class="text-input-file event-img-1 mt-4" data-field-id="${timestamp}">※画像を1枚選んでアップロードしてください。</div>
        <button type="button" style="height: 30px; width: 70px; background-color: #dc3545; color: white; border: none; font-size: 13px;" class="btn mt-4 d-flex align-items-center justify-content-center" onclick="removeImageField(this)">削除</button>
      </div>
    `;
    imageFields.appendChild(newField);
  };

  window.removeImageField = function(button) {
    const fieldContainer = button.closest('.mb-2');
    const input = fieldContainer.querySelector('input[type="file"]');
    
    if (input) {
      const fieldId = input.getAttribute('data-field-id');
      if (fieldId) {
        const previewContainer = $(`#image-preview [data-field-id="${fieldId}"]`);
        if (previewContainer.length > 0) {
          previewContainer.remove();
        }
        
        const fileNameDiv = document.querySelector(`.text-input-file[data-field-id="${fieldId}"]`);
        if (fileNameDiv) {
          fileNameDiv.textContent = '※画像を1枚選んでアップロードしてください。';
        }
      }
    }
    
    fieldContainer.remove();
  };

  window.previewImage = function(input, isExistingField = false) {
    const preview = $('#image-preview');
    const files = input.files;
    let fieldId = input.getAttribute('data-field-id');
    if (!fieldId) {
      fieldId = input.name || input.id || Math.random().toString(36);
    }
    
    if (files && files[0]) {
      const file = files[0];
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = function(e) {
          const existingPreview = preview.find(`[data-field-id="${fieldId}"]`);
          if (existingPreview.length > 0) {
            existingPreview.remove();
          }
          const imgContainer = $('<div class="position-relative d-inline-block me-3 mb-3">');
          imgContainer.attr('data-field-id', fieldId);
          const img = $('<img>');
          img.attr('src', e.target.result)
            .css({ maxWidth: '120px', maxHeight: '120px', width: '120px', height: '120px' })
            .addClass('rounded border object-fit-cover')
            .attr('alt', file.name);
          const removeBtn = $('<button type="button" class="btn position-absolute" onclick="removePreview(this, \'' + fieldId + '\')" style="top: -8px; right: -8px; width: 20px; height: 20px; border-radius: 50%; padding: 0; font-size: 10px; line-height: 1; display: flex; align-items: center; justify-content: center; background-color: #dc3545; color: white; border: none;">×</button>');
          imgContainer.append(img).append(removeBtn);
          preview.append(imgContainer);
        };
        reader.readAsDataURL(file);
      }
    } else {
      const existingPreview = preview.find(`[data-field-id="${fieldId}"]`);
      if (existingPreview.length > 0) {
        existingPreview.remove();
      }
    }
    showFileName(input);
  };

  window.showFileName = function(input) {
    var fieldId = input.getAttribute('data-field-id');
    var fileNameDiv = document.querySelector('.text-input-file[data-field-id="' + fieldId + '"]');
    var fileName = input.files && input.files.length > 0 ? input.files[0].name : '※画像を1枚選んでアップロードしてください。';
    if (fileNameDiv) {
      fileNameDiv.textContent = fileName;
    }
  };

  window.removePreview = function(button, fieldId) {
    const container = button.closest('.position-relative');
    const destroyField = container.querySelector('.destroy-image');
    var fileNameDiv = document.querySelector('.text-input-file[data-field-id=\"' + fieldId + '\"]');
    if (fileNameDiv) {
      fileNameDiv.textContent = '※画像を1枚選んでアップロードしてください。';
    }
    if (destroyField) {
      destroyField.value = '1';
      container.style.display = 'none';
    } else {
      container.remove();
      console.log(fieldId);
      var input = document.querySelector('input[type=\"file\"][data-field-id=\"' + fieldId + '\"]');
      if (input) input.value = '';
    }
  };

  function checkAndToggleImageLabel() {
    const imagePreview = document.getElementById('image-preview');
    const imageLabel = document.querySelector('.admin-message-image-label');
    
    if (!imagePreview || !imageLabel) return;
    
    const hasUploadedImages = imagePreview.children.length > 0;
    
    if (!hasUploadedImages) {
      imageLabel.style.display = 'none';
    } else {
      imageLabel.style.display = 'block';
    }
  }

  function bindImageInputEvent() {
  }

  bindImageInputEvent();

  $(document).on('click', '.btn-preview-admin-message', function (e) {
    $('#error-title').text('');
    $('#error-content').text('');
    const title = $('#admin_message_title').val();
    const content = $('#admin_message_content').val();
    let valid = true;
    if (!title || !title.trim()) {
      $('#error-title').text('件名を入力してください。');
      valid = false;
    }
    if (!content || !content.trim()) {
      $('#error-content').text('お知らせ内容を入力してください。');
      valid = false;
    }
    if (content && content.length > 3000) {
      $('#error-content').text('お知らせ内容は3000文字以内で入力してください。');
      valid = false;
    }
    if (!valid) {
      e.preventDefault();
      return false;
    }
    $('#admin_message_title').addClass('d-none');
    if ($('#preview-title-text').length === 0) {
      $('<div id="preview-title-text" class="form-control bg-light mb-2">' + $('<div>').text(title).html() + '</div>')
        .insertAfter('#admin_message_title');
    } else {
      $('#preview-title-text').text(title);
    }
    $('#admin_message_content').addClass('d-none');
    if ($('#preview-content-text').length === 0) {
      $('<div id="preview-content-text" class="form-control bg-light" style="white-space: pre-wrap; word-wrap: break-word;">' + $('<div>').text(content).html() + '</div>')
        .insertAfter('#admin_message_content');
    } else {
      $('#preview-content-text').css('white-space', 'pre-wrap').css('word-wrap', 'break-word').text(content);
    }
    $('#image-fields').addClass('d-none');
    $('.btn-success').addClass('d-none');
    $('#image-preview .btn-danger').addClass('d-none');
    
    const imagePreview = document.getElementById('image-preview');
    const imageLabel = document.querySelector('.admin-message-image-label');
    if (imagePreview && imageLabel) {
      const visibleImages = Array.from(imagePreview.children).filter(child => 
        child.style.display !== 'none' && child.offsetParent !== null
      );
      
      if (visibleImages.length === 0) {
        imageLabel.style.display = 'none';
      }
    }
    
    $('.btn-back-admin-message').removeClass('d-none');
    $('.btn-preview-admin-message').addClass('d-none');
    $('.btn-send-admin-message').removeClass('d-none');
    $('.btn-to-admin-message-index').addClass('d-none');
  });

  $(document).on('click', '.btn-back-admin-message', function () {
    $('#admin_message_title').removeClass('d-none');
    $('#preview-title-text').remove();
    $('#admin_message_content').removeClass('d-none');
    $('#preview-content-text').remove();
    
    $('#image-fields').removeClass('d-none');
    $('.btn-success').removeClass('d-none');
    
    $('#image-preview .btn-danger').removeClass('d-none');
    
    const imageLabel = document.querySelector('.admin-message-image-label');
    if (imageLabel) {
      imageLabel.style.display = 'block';
    }
    
    $('.btn-back-admin-message').addClass('d-none');
    $('.btn-preview-admin-message').removeClass('d-none');
    $('.btn-send-admin-message').addClass('d-none');
    $('.btn-to-admin-message-index').removeClass('d-none');
  });

  $(document).on('mousedown', '.btn-file-input-mess', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const container = $(this).closest('.position-relative');
    const fileInput = container.find('input[type="file"]')[0];
    
    if (fileInput) {
      $(fileInput).trigger('click');
    }
    
    return false;
  });

}); 